import skills from './skills'

export const SKILLS = skills

export default {
  SKILLS: skills,
}
